import slugify from 'slugify'

export default (city, ctaLink) =>
  `/${slugify(city, { lower: true })}/${slugify(ctaLink, { lower: true })}`
